import {
  Button,
  Card, Icon,
  notification, Popconfirm,
  Tooltip
} from 'antd'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormUtils, TableComp } from 'sz-react-utils-lite'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import Request from '../../../request'
import styles from './styles.less'
import { allUserExportFxn, getAllUsersFxn, deleteAdminUserFxn } from '../actions'
import EditAdminUser from '../editAdmin'
import ActivityListAdmin from '../allAdminUsers/articleActivityDrawer'
import EditUser from '../drawers/editUser'
import MemberHistory from '../../article/reviewer/memberHistory'
import AuthorHistory from '../../article/drawers/authorHistory'
import { onlineSubmissionExportFxn } from '../../onlineSubmission/actions'
import { apiUrl } from '../../../settings'
import ChangePasswordDrawer from '../drawers/changePassword'

const regExpFilters = ['name', 'local.email', 'userType']

class AllUsers extends Component {
  events = {
    showEdit: (data) => {
      this.setState({
        visible: true, userId: data._id,
        userType: data.userType
      })
    },
    hideEdit: () => {
      this.setState({
        visible: false, userId: '', userType: ''
      })
    },
    onSubmit: () => {
      this.setState({
        visible: false, userId: '', userType: ''
      }, () => {
        this.table.current.reload()
      })
    },
    showHistory: (data) => {
      this.setState({
        reviewerState: {
          visible: true,
          reviewerId: data.reviewer_Id,
          data: {
            reviewerId: data.reviewerId,
            name: data.name,
            email: data.local ? data.local.email : ''
          }
        }
      })
    },
    hideHistory: () => {
      this.setState({
        reviewerState: {
          visible: false,
          reviewerId: '',
          data: {}
        }
      })
    },
    showAuthorHistory: (data) => {
      this.setState({
        authorHistoryState: {
          visible: true,
          emailId: data.local.email
        }
      })
    },
    hideAuthorHistory: () => {
      this.setState({
        authorHistoryState: {
          visible: false,
          emailId: '',
          data: {}
        }
      })
    }
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
    this.state = {
      userId: '',
      visible: false,
      userType: '',
      reviewerState: {
        visible: false,
        data: {}
      },
      authorHistoryState: {
        visible: false,
        emailId: ''
      },
      changePasswordVisible: false,
      changePasswordUserId: '',
      activityListOpen: false,
      adminUserId: '',
      name: '',
      editAdminVisible: false,
      editAdminVal: {},
      editAdminIndex: ''
    }
  }

  showChangePassword = (record) => {
    this.setState({
      changePasswordVisible: true,
      changePasswordUserId: record._id
    })
  }

  hideChangePassword = () => {
    this.setState({
      changePasswordVisible: false,
      changePasswordUserId: ''
    })
  }

  changePasswordSuccessful = () => {
    this.setState({
      changePasswordVisible: false,
      changePasswordUserId: ''
    })
    this.table.current.reload()
  }

  showActivityList = (val) => {
    this.setState({ activityListOpen: true, adminUserId: val._id, name: val.name })
  }

  handleDeleteAdmin = async record => {
    let { dispatch } = this.props
    await dispatch(deleteAdminUserFxn(record))
    this.table.current.reload()
  }

  showEditAdmin = (val, index) => {
    this.setState({ editAdminVisible: true, editAdminVal: val, editAdminIndex: index })
  }

  hideEditAdmin = () => {
    this.setState({ editAdminVisible: false })
  }

  editAdminSuccessfull = () => {
    this.setState({ editAdminVisible: false })
    this.table.current.reload()
  }

  apiRequest = params => {
    let { dispatch } = this.props
    return new Promise(async resolve => {
      let data = await dispatch(
        getAllUsersFxn({
          ...params,
          results: 5000,
          count: 5000,
          regExFilters: regExpFilters
        })
      )
      this.setState({
        filteredUsers: data.data
      })
      resolve(data)
    })
  }

  deleteUser = params => {
    Request.deleteUserApi(params).then(data => {
      if (data.type) {
        notification.success({
          message: data.msg
        })
        this.reload()
      } else {
        notification.error({
          message: data.msg
        })
      }
    })
  }

  reload = () => {
    this.table.current.reload()
  }
  exportExcel = async () => {
    let { dispatch } = this.props
    const { filteredUsers } = this.state
    let resp = await dispatch(allUserExportFxn({ data: filteredUsers }))
    if (resp && resp.success) {
      window.open(`${apiUrl}${resp.fileName}`, 'Download')
    }
  }

  componentDidMount() {
  }

  render() {
    let { currentUser } = this.props
    let { state: { visible, userId, userType, reviewerState, authorHistoryState, filteredUsers }, events } = this

    let isOnlyAdmins = filteredUsers && filteredUsers.length > 0 && filteredUsers.every(u => u.userType === 'Admin');
    let isOnlyAuthors = filteredUsers && filteredUsers.length > 0 && filteredUsers.every(u => u.userType === 'Author');
    let isOnlyInstitutes = filteredUsers && filteredUsers.length > 0 && filteredUsers.every(u => u.userType === 'Institute');

    const standardUserTypes = [
      'Admin',
      'Author',
      'Institute',
      'Reviewer',
      'User'
    ]
    let userTypeFilters = standardUserTypes.map(t => ({ text: t, value: t }))

    const columns = [
      {
        title: 'Name',
        key: 'name',
        sorter: true,
        dataIndex: 'name',
        searchTextName: 'name',
        filterByRegex: true,
        fixed: 'left',
        width: 130,
        render: (text, record) => `${record.name || ''} ${record.lastName || ''}`.trim()
      },
      {
        title: 'User Type',
        dataIndex: 'userType',
        key: 'userType',
        filters: userTypeFilters,
        fixed: 'left',
        width: 130,
        render: (text, record) => (
          <div>
            <div>{text}</div>
            {text === 'Reviewer' && record.reviewerId ? (
              <div style={{ fontSize: '13px', color: 'gray' }}>
                {record.reviewerId}
              </div>
            ) : null}
            {text === 'Admin' && record.designation ? (
              <div style={{ fontSize: '13px', color: 'gray' }}>
                {record.designation}
              </div>
            ) : null}
            {['Author', 'Institute'].includes(text) && record.department ? (
              <div style={{ fontSize: '13px', color: 'gray' }}>
                {record.department}
              </div>
            ) : null}
          </div>
        )
      },
      {
        title: 'Email',
        dataIndex: 'local.email',
        key: 'local.email',
        filterByRegex: true,
        searchTextName: 'local.email',
        fixed: 'left',
        width: 150
      },
      ...(currentUser && currentUser.isAdmin
        ? [{
          title: 'Password',
          dataIndex: 'displayPassword',
          key: 'displayPassword',
          searchTextName: 'displayPassword',
          filterByRegex: true,
          width: '120px'
        }]
        : []),
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
        width: 180
      },
      ...(isOnlyInstitutes ? [] : [{
        title: 'Institute',
        dataIndex: 'instituteName',
        key: 'instituteName',
        width: 180
      }]),
      ...((isOnlyInstitutes || isOnlyAdmins) ? [] : [
        {
          title: 'Designation',
          dataIndex: 'designation',
          key: 'designation',
          render: (text, record) => record.userType === 'Admin' ? null : text
        }
      ]),
      ...((isOnlyAuthors || isOnlyInstitutes) ? [
        {
          title: 'Postal Code',
          dataIndex: 'postalCode',
          key: 'postalCode',
          searchTextName: 'postalCode',
          filterByRegex: true,
          width: 120
        }
      ] : [
        {
          title: 'MobileNo',
          dataIndex: 'mobileNo',
          key: 'mobileNo'
        }
      ]),

      ...(isOnlyAuthors ? [] : [
        {
          title: 'userName',
          dataIndex: 'userName',
          key: 'userName'
        }
      ]),
      {
        title: 'Country',
        dataIndex: 'country',
        key: 'country'
      },
      {
        title: 'Action',
        key: 'actions',
        width: 150,
        fixed: 'right',
        render: (item, record) => {
          return (
            <div className={'wrapRow'}>
              {['User', 'Institute'].includes(item.userType) ? (
                <React.Fragment>
                  <Tooltip title='Show Details'>
                    <Popconfirm
                      title={'Are you sure, you want to delete user?'}
                      onConfirm={() => {
                        this.deleteUser(item)
                      }}>
                      <a className={'btn round btn-danger btn-sm'}>
                        <Icon type={'delete'} /> Delete
                      </a>
                    </Popconfirm>
                  </Tooltip>
                </React.Fragment>
              ) : null}

              {['User', 'Author', 'Institute', 'Reviewer'].includes(item.userType) ?
                <a className={'btn round btn-default btn-sm'} onClick={() => {
                  this.events.showEdit(record)
                }}>Edit</a> : null}

              {item.userType === 'Author' ? (
                <a className={'btn round btn-default btn-sm'} style={{ marginLeft: '10px' }} onClick={() => {
                  this.events.showAuthorHistory(record)
                }}>View </a>
              ) : null}

              {item.userType == 'Admin' ? (
                <React.Fragment>
                  <a className={'btn round btn-default btn-sm'} onClick={() => {
                    this.showEditAdmin(record, null)
                  }}>Edit</a>
                  <a className={'btn round btn-default btn-sm'} style={{ marginTop: '6px' }} onClick={() => {
                    this.showActivityList(record)
                  }}>Article Activities</a>
                  <Popconfirm
                    title={'Are you sure, you want to delete user?'}
                    onConfirm={() => {
                      this.handleDeleteAdmin(item)
                    }}>
                    <a className={'btn round btn-danger btn-sm'} style={{ marginTop: '6px' }}>
                      <Icon type={'delete'} /> Delete
                    </a>
                  </Popconfirm>
                </React.Fragment>
              ) : null}

              {item.userType == 'Reviewer' ?
                <a className={'btn round btn-default btn-sm'} style={{ marginLeft: '10px' }} onClick={() => {
                  this.events.showHistory(record)
                }}>View</a> : null}

              <a className={'btn round btn-default btn-sm'} style={{ marginTop: '6px' }} onClick={() => {
                this.showChangePassword(record)
              }}>Change Password</a>

            </div>
          )
        }
      }
    ]
    return (
      <PageHeaderWrapper title={'All Users'} content={[
        <>
          <Button
            key='1'
            type='primary'
            onClick={() => {
              this.exportExcel()
            }}>
            <Icon type={'file'} />
            Export
          </Button>
        </>
      ]}>
        <Card bordered={true}>
          <TableComp
            ref={this.table}
            extraProps={{ scroll: { x: 1800 } }}
            columns={columns}
            apiRequest={this.apiRequest}
          />
        </Card>

        {visible ? <EditUser
          visible={visible} userId={userId}
          userType={userType}
          onSubmit={events.onSubmit}
          onClose={events.hideEdit} /> : ''}


        {reviewerState.visible ? (
          <MemberHistory
            {...reviewerState}
            onClose={events.hideHistory}
          />
        ) : null}

        {authorHistoryState && authorHistoryState.visible ? (
          <AuthorHistory
            {...authorHistoryState}
            onClose={events.hideAuthorHistory}
          />
        ) : null}

        {this.state.changePasswordVisible ? (
          <ChangePasswordDrawer
            visible={this.state.changePasswordVisible}
            userId={this.state.changePasswordUserId}
            onClose={this.hideChangePassword}
            onSubmitSuccess={this.changePasswordSuccessful}
          />
        ) : null}

        {this.state.editAdminVisible ? (
          <EditAdminUser
            visible={this.state.editAdminVisible}
            editVal={this.state.editAdminVal}
            indexVal={this.state.editAdminIndex}
            onClose={this.hideEditAdmin}
            editSuccessfull={this.editAdminSuccessfull}
          />
        ) : null}

        {this.state.activityListOpen && this.state.adminUserId ? (
          <ActivityListAdmin
            visible={this.state.activityListOpen}
            onClose={() => {
              this.setState({ activityListOpen: false })
            }}
            operatedByUserId={this.state.adminUserId}
            name={this.state.name}
          />
        ) : null}

      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = (
  {
    global
  }
) => (
  {
    categories: global.categories,
    currentUser: global.currentUser
  }
)
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllUsers)
